<template>
  <main
    id="page"
    :class="[
      'page-view',
      currentPage,
      { 'case-study': !!route.query.caseStudy },
    ]"
    :style="{
      '--page-color': currentCaseStudy
        ? 'var(--color-white)'
        : `var(--framework-${currentPage})`,
    }"
  >
    <RoundIconButton
      :class="['page-view__scroll-up-btn', { hidden }]"
      :icon="arrowUp"
      :aria-label="$t('general.ctas.scrollUp')"
      @click="scrollUp"
    />
    <template v-if="currentContent">
      <component
        v-for="component of currentContent"
        :key="i18n.locale.value + currentPage + currentCaseStudy + component.id"
        :is="pageComponents[component.component]"
        :currentPage="currentPage"
        :id="component.id"
        v-bind="component.content"
        :nextPage="pageLinks[currentPageIndex + 1] || pageLinks[1]"
      />
    </template>

    <NavFooter
      v-if="showFooter"
      :currentPage="currentPage"
      :allLinks="pageLinks"
      :caseStudies="Object.keys(caseStudies)"
      :currentCaseStudy="currentCaseStudy"
      :key="i18n.locale.value + currentPage + currentCaseStudy"
    />
  </main>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import RoundIconButton from "@/components/atoms/RoundIconButton.vue";
import { arrowUp } from "@/assets/icons/icons.js";

import CTASection from "../components/molecules/CTASection.vue";
import NavigationSection from "../components/molecules/NavigationSection.vue";
import PageHero from "../components/molecules/PageHero.vue";
import CaseStudyHero from "../components/molecules/CaseStudyHero.vue";
import CardSlider from "../components/molecules/CardSlider.vue";
import HomeHero from "../components/molecules/HomeHero.vue";
import TextSection from "../components/molecules/TextSection.vue";
import TextSectionGrey from "../components/molecules/TextSectionGrey.vue";
import TextSectionWhite from "../components/molecules/TextSectionWhite.vue";
import TextSectionOverflow from "../components/molecules/TextSectionOverflow.vue";
import KPISection from "../components/molecules/KPISection.vue";
import GraphSection from "../components/molecules/GraphSection.vue";

// import NavFooter from "../components/general/NavFooter.vue";
// import Navbar from "../components/general/Navbar.vue";
// molecules
import DownloadModule from "@/components/molecules/DownloadModule.vue";
import ParagrafoDefault from "../components/molecules/ParagrafoDefault.vue";

import NavFooter from "../components/atoms/NavFooter.vue";

const route = useRoute();
const i18n = useI18n();
const { tm } = useI18n();

const pageComponents = {
  CTASection,
  NavigationSection,
  PageHero,
  CardSlider,
  HomeHero,
  CaseStudyHero,
  TextSection,
  TextSectionGrey,
  TextSectionOverflow,
  TextSectionWhite,
  KPISection,
  DownloadModule,
  ParagrafoDefault,
  GraphSection,
};

// const currentPage = ref("");

const pages = computed(() => tm("pages"));
const caseStudies = computed(() => tm("case-study"));
const pageLinks = computed(() => Object.keys(pages.value));

const showFooter = computed(
  () => route.params.page !== "home" || route.query.caseStudy
);
const currentPage = computed(() => route.params.page);
const currentPageIndex = computed(() =>
  pageLinks.value.indexOf(currentPage.value)
);
const currentCaseStudy = computed(() => route.query.caseStudy);

const currentContent = computed(() =>
  route.query.caseStudy
    ? caseStudies.value[route.query.caseStudy]
    : pages.value[route.params.page]
);
// scroll button
const hidden = ref(true);

window.addEventListener("scroll", () => {
  hidden.value = window.scrollY == 0;
});
function scrollUp() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}
</script>

<style lang="scss" scoped>
.page-view {
  &__scroll-up-btn {
    position: fixed;
    bottom: 1.25rem;
    right: 1.5rem;
    z-index: 2;
    color: var(--brand-weaker);
    transition: bottom .8s ease;
    &.hidden {
      bottom: -5rem;
    }
  }
}
</style>
